import useMerchantWebPortalAxios from "../../utils/axiosWeb";
import { useDispatch } from "react-redux";
import {
  settingBillsData,
  settingBillsObjectData,
} from "../../features/billsPageSlice";
import useResponse from "../../app/useResponse";

function useAlfaApi() {
  const dispatch = useDispatch();
  const MerchantWebPortalAxios = useMerchantWebPortalAxios();
  const { successResponse, errorResponse } = useResponse();
  const errorRes = {
    response: {
      data: {
        isPopup: true,
        PopupTitle: "Error",
        PopupDescription: "Something went wrong. Please try again later.",
      },
    },
  };

  const checkWebKey = async () => {
    const res = await MerchantWebPortalAxios.get(`/api/alfa`);

    if (res?.data?.status) {
      sessionStorage.setItem("provider", String(res.data.provider));
    }

    return res.data;
  };

  const KatshCheckBill = async (phoneNumber) => {
    dispatch(settingBillsData({ field: "isloading", value: "pending" }));

    try {
      const payload = {
        phoneNumber,
        pin: sessionStorage.getItem("Token"),
        suyoolUserId: sessionStorage.getItem("SessionID"),
        isCorporate: true,
      };

      const res = await MerchantWebPortalAxios.post(`/alfa/checkbill`, payload);

      if (res?.data?.success && res?.data?.status) {
        const raw = res.data.payload || {};
        const details = raw.data || raw;

        dispatch(
          settingBillsObjectData({
            mainField: "alfa",
            field: "MobileNumber",
            value: phoneNumber,
          }),
        );
        dispatch(
          settingBillsObjectData({
            mainField: "alfa",
            field: "katshOrderDetailsId",
            value: res.data.katshOrderDetailsId,
          }),
        );
        dispatch(
          settingBillsObjectData({
            mainField: "alfa",
            field: "referenceKey",
            value: details.ReferenceKey || details.referenceKey,
          }),
        );
        dispatch(
          settingBillsObjectData({
            mainField: "alfa",
            field: "displayData",
            value: details,
          }),
        );
        dispatch(
          settingBillsObjectData({
            mainField: "alfa",
            field: "displayFee",
            value: details.Fees || details.fees || 0,
          }),
        );

        dispatch(
          settingBillsData({
            field: "currentPage",
            value: "payment-confirmation",
          }),
        );
        return res;
      }

      const popup = res?.data?.data?.Popup;

      if (popup?.isPopup) {
        successResponse(popup);
      } else {
        errorResponse({
          response: {
            status: 400,
            data: {
              isPopup: true,
              PopupTitle: "Validation Error",
              PopupDescription: res?.data?.message || "Something went wrong.",
            },
          },
        });
      }

      return res;
    } catch (error) {
      errorResponse(error);
      throw error;
    } finally {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
    }
  };

  const AlfaBill = async (mobileNumber) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/alfa/bill`, {
        mobileNumber: mobileNumber,
      });
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));

      if (res.data.status) {
        if (res.data.data.invoiceId === -1) {
          successResponse(res.data.data.Popup);
        } else {
          dispatch(
            settingBillsObjectData({
              mainField: "alfa",
              field: "MobileNumber",
              value: mobileNumber,
            }),
          );
          dispatch(
            settingBillsObjectData({
              mainField: "alfa",
              field: "InvoiceId",
              value: res.data.data.invoiceId,
            }),
          );
          dispatch(
            settingBillsData({ field: "currentPage", value: "pin-confirm" }),
          );
        }
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const RetrieveResults = async (mobileNumber, Pin, invoicesId) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(
        `/api/alfa/bill/RetrieveResults`,
        {
          mobileNumber: mobileNumber,
          currency: "LBP",
          Pin: Pin,
          invoicesId: invoicesId,
        },
      );
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status) {
        if (res.data.data.postpayed !== -1) {
          dispatch(
            settingBillsObjectData({
              mainField: "alfa",
              field: "displayData",
              value: res.data.data.displayData,
            }),
          );
          dispatch(
            settingBillsObjectData({
              mainField: "alfa",
              field: "displayFee",
              value: res.data.data.displayedFees,
            }),
          );
          dispatch(
            settingBillsObjectData({
              mainField: "alfa",
              field: "postpayed",
              value: res.data.data.postpayed,
            }),
          );
          dispatch(
            settingBillsData({
              field: "currentPage",
              value: "payment-confirmation",
            }),
          );
        } else {
          successResponse(res.data.data.Popup);
        }
      }
      return res.data;
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const PayAlfaBill = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(
        `/api/alfa/bill/pay`,
        payload,
      );
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const GetAlfaCards = async () => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.get(`/api/alfa/ReCharge`);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        return res.data;
      } else {
        successResponse(res.data.data.Popup);
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const BuyAlfaCard = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(
        `/api/alfa/BuyPrePaid`,
        payload,
      );
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        dispatch(
          settingBillsData({
            field: "prepaidRes",
            value: res?.data?.data?.Popup,
          }),
        );
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const setPaymentStatus = async (payload) => {
    try {
      const res = await MerchantWebPortalAxios.post(
        "/api/alfa/setPaymentStatus",
        payload,
      );
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  return {
    checkWebKey,
    GetAlfaCards,
    BuyAlfaCard,
    AlfaBill,
    RetrieveResults,
    PayAlfaBill,
    KatshCheckBill,
  };
}

export default useAlfaApi;
